// *** DATE SERVICE ***

// *** CHECK IF DATE IS VALID ***
export const dateIsValid = (dateString, acceptEmpty = false) => {
    return (dateString === '' && acceptEmpty) || new Date(dateString).toString() !== 'Invalid Date';
};

// *** GET LOCAL DATE ***
// Used to format a date string for the current locale.
export const getLocalDate = (dateString, lang, time = false, sec = false) => {
    if (dateString === null || dateString === undefined) return '';
    const date = dateString.length > 0 ? new Date(dateString) : new Date();
    if (date.toString() === 'Invalid Date') return '';

    const isoDateTime = getLocalDateISOString(date, true);
    let localTime = isoDateTime.slice(11, 19);
    if (!sec) localTime = localTime.slice(0, -3);
    let output = '';

    switch (lang) {
        case 'fi':
        case 'sv':
            output = new Date(isoDateTime).toLocaleDateString('fi');
            if (time) output = `${output} ${localTime.replace(/\:/g, '.')}`;
            break;
        case 'en':
            output = isoDateTime.slice(0, 10);
            if (time) output = `${output} ${localTime}`;
            break;
    }

    return output;
};

// *** GET LOCAL DATE ISO STRING ***
// Used to format a date in the ISO 8601 date format, taking into account the user's time zone.
export const getLocalDateISOString = (date, timeIncluded = false) => {
    const isoDateTime = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000).toISOString();
    return timeIncluded ? isoDateTime : isoDateTime.slice(0, 10);
};
